export default __webpack_public_path__ + "static/media/Bajaj.89d68cac.png";